///unused!
//Display Variant C

<template style="background-color: inherit" >
<div id="variant-three-container" style="backgroud-color: inherit">
	<div class="feature-container" style="backgroud-color: inherit">
		<div class="landing-red light-text feature-headline">
			{{feature.headline}}
		</div>
		
		<div class="feature-desc-short content-subtext light-text">
			{{feature.descShort}}
		</div>
	</div>
	<div class="image-block">
		<img :src="baseUrl + feature.images[0].url"/>
		<div class="feature-desc-long content-description light-text" style="background-color: inherit; opacity: 0.9">			
			<div class="inner-text">{{feature.descLong}}</div>
		</div>
	</div>
</div>
</template>

<script>
		export default {
			Name: 'FeatureVariantThree',
			
			props: {
				feature: {type:Object},
				baseUrl: String,
			}
		}
		
</script>

<style scoped>
	.feature-container {
		max-width: 50%;
		align-items: center;
	}
	
	.feature-desc-long {
		width: 40%;
		z-index: 100;
		padding: 1.5em;
		background-color: #e5e5e5;
		position: absolute;
		bottom: 0;
		margin: 0;
		left: 30%;
		right:0;
		padding-bottom:0;
		max-height: 20%;
		text-align: left;
		width:100%;
	}
	
	img {
		left: 0; bottom: 0;
		position: absolute;
		float: left;
		max-width: 900px;
		height:400px;
	}
	
	.feature-headline {
		padding-top: 1em;
	}
	
	.image-block {
		height: 100%;
		position: relative;
		background-color: inherit;
		margin: auto;
		height: 400px;
		max-width:90%
	}
	
	.inner-text {
		width:40%;
	}
	
	@media (max-width: 1199px) {
		.inner-text {
			width:60%;
	}
	}

	@media (max-width: 991px) {
		.inner-text {
			width:95%;
	}

		.feature-desc-long {
			width: 70%;
			left: 20%;
		}
	}
	
	
	@media (max-width: 767px) {
		.images-container {
			margin-top: 150px;
			max-width: 100%;
		}
		.image {
		max-width: 75%;
		}
		
	}
	
	@media (max-width: 575px) {
		.feature-desc-long {
			width: 60%;
			left: 25%;
		}
		
		.image-block {
		}

	}
	
	

</style>


